/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { MachineEdgeState } from "./state.js";
export class MachineResult {
    descriptor;
    inputs;
    missingInputs;
    current;
    opportunities;
    newOpportunities;
    state;
    outputs;
    partialOutputs;
    constructor(descriptor, inputs, missingInputs, currentOpportunity, opportunities, newOpportunities, state, partialOutputs) {
        this.descriptor = descriptor;
        this.inputs = inputs;
        this.missingInputs = missingInputs;
        this.current = currentOpportunity;
        this.opportunities = opportunities;
        this.newOpportunities = newOpportunities;
        this.state = state;
        this.partialOutputs = partialOutputs;
    }
    /**
     * `true` if the machine decided that the node should be skipped, rather than
     * visited.
     */
    get skip() {
        return this.missingInputs.length > 0;
    }
    static fromObject(o) {
        const edgeState = new MachineEdgeState();
        edgeState.constants = o.state.constants;
        edgeState.state = o.state.state;
        return new MachineResult(o.descriptor, o.inputs, o.missingInputs, o.current, o.opportunities, o.newOpportunities, edgeState, o.partialOutputs);
    }
}
//# sourceMappingURL=result.js.map